// extracted by css-extract-rspack-plugin
export default {"shimmerTitle":"_bb10f0c4","shimmerLink":"_1ebcc6a4","shimmerTitleMobile":"_6eb0b744","itemsWrapper":"_41aae394","itemMobile":"_78aaab34"};